<template>
	<v-dialog max-width="700px" :value="true" no-click-animation persistent hide-overlay>
		<v-card class="pa-0">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white"> 帳票作成 </v-app-bar-title>
				<v-spacer />
				<ExcelTemplateHelpDialog :name="'excelTemplate'" :openBtnColor="'primary'" />
			</v-app-bar>
			<v-form ref="form" v-model="valid" class="pa-2">
				<ExcelTemplateForm
					:excel_template.sync="excel_template"
					:modelNames="modelNames"
					:departments="departments"
					:showFileInput="true"
					:disabledBaseModelSelect="false"
				/>
				<v-row no-gutters class="mt-4" justify="center">
					<v-btn color="secondary" :disabled="!valid" @click="submitForm"> 登録する </v-btn>
				</v-row>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import ExcelTemplateForm from "./components/ExcelTemplateForm.vue"
import ExcelTemplateHelpDialog from "../shared/HelpDialog.vue"

export default {
	components: {
		ExcelTemplateForm,
		ExcelTemplateHelpDialog,
	},
	data() {
		return {
			excel_template: {
				name: null,
				base_model: null,
				exclusive_flag: false,
				department_id: null,
				file: null,
			},
			valid: false,
			modelNames: [],
			departments: [],
		}
	},
	mounted() {
		const headers = authenticate.setHeader()
		const url = "/erp/v1/excel_templates/new"
		axios
			.get(url, { headers })
			.then((res) => {
				this.modelNames = res.data.base_models
				this.departments = res.data.departments
			})
			.catch((err) => {
				errorHandling.errorResponse(err)
			})
	},
	methods: {
		submitForm() {
			let headers = authenticate.setHeader()
			headers["Content-type"] = "multipart/form-data"
			const formData = new FormData()
			formData.set("excel_template[name]", this.excel_template.name)
			formData.set("excel_template[base_model]", this.excel_template.base_model)
			formData.set("excel_template[exclusive_flag]", this.excel_template.exclusive_flag)
			if (this.excel_template.department_id)
				formData.set("excel_template[department_id]", this.excel_template.department_id)
			formData.append(
				"excel_template[file]",
				new Blob([this.excel_template.file.data], {
					type: this.excel_template.file.type,
				}),
				this.excel_template.file.fileName
			)
			const url = "/erp/v1/excel_templates/"
			axios
				.post(url, formData, { headers })
				.then((res) => {
					this.$router.push({ name: "excel_template_edit", params: { id: res.data } })
					this.$store.dispatch("setFlash", {
						text: "帳票を作成しました",
						type: "notice",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
